import { render, staticRenderFns } from "./nimp_design_selector.vue?vue&type=template&id=2a11066f&scoped=true&"
import script from "./nimp_design_selector.vue?vue&type=script&lang=js&"
export * from "./nimp_design_selector.vue?vue&type=script&lang=js&"
import style1 from "./nimp_design_selector.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11066f",
  null
  
)

export default component.exports